import todosSlice from './todosSlice'

export * from './types'

export const { actions: todosActions, reducer: todosReducer } = todosSlice
